import { notification } from 'antd';

const openNotification = (isSuccess, title, description) => {
    isSuccess ?

        notification.success({
            key: 'updatable',
            message: title,
            description: description,
            duration: 1
        }) :
        notification.error({
            key: 'updatable',
            message: title,
            description: description,
            duration: 1
        })

};


export default openNotification;